import { render, staticRenderFns } from "./debug.vue?vue&type=template&id=3c7f2d33&scoped=true"
import script from "./debug.vue?vue&type=script&lang=js"
export * from "./debug.vue?vue&type=script&lang=js"
import style0 from "./debug.vue?vue&type=style&index=0&id=3c7f2d33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7f2d33",
  null
  
)

export default component.exports